import React from 'react';
import '../styles/Custom.css';

const Typography = ({
    text,
    color,
    size,
    family,
    lineheight,
    transform,
    className = '',
    disabled = false,
    weight,
    opacity,
    onClick,
    letterspacing,
    ...props
}) => {
    return (
        <div onClick={onClick} className={`custom-normal-text ${className} ${disabled ? 'disabled' : ''}`} style={{ color: color, fontWeight: weight, fontSize: size, opacity: opacity, fontFamily: family, lineHeight: lineheight, textTransform: transform, letterSpacing: letterspacing, ...props }}>
            {text}
        </div>
    );
};

export default Typography;